/**
 * Predictable E2E selectors for the participant survey (current page only).
 *
 * - Top-level questions (DOM order): field-0, field-1, …
 * - Conditional follow-ups under parent slot N: field-N-0, field-N-1, …
 * - Options within a field use 0-based order (sorted sequence): radio-option-0, …
 *
 * IDs do not use API question/option ids so automation can target stable patterns.
 */
export type SurveyParticipantFieldId = string;

const root = (fieldId: SurveyParticipantFieldId) =>
  `survey-participant-field-${fieldId}`;

/** Wrapper around one question block (matches Flex in question-list). */
export const surveyParticipantFieldContainer = (
  fieldId: SurveyParticipantFieldId
) => `${root(fieldId)}-container`;

/** Section / non-Flex blocks (e.g. section heading). */
export const surveyParticipantFieldSection = (
  fieldId: SurveyParticipantFieldId
) => `${root(fieldId)}-section`;

/** One control or control group under a field, e.g. single-line-input, radio-option-2. */
export const surveyParticipantFieldControl = (
  fieldId: SurveyParticipantFieldId,
  controlSuffix: string
) => `${root(fieldId)}-${controlSuffix}`;
